import { cva } from 'class-variance-authority';

export const textAreaRootVariants = cva(
  [
    '[&>svg]:fill-current',
    'flex',
    'search-input-none',
    // 'relative',
    'items-center',
    'self-stretch',
    'relative',
    'rounded-radius-comp-form-round',
    //default
    'bg-color-comp-text-field-container-enabled',
    '[&>textarea]:text-color-comp-text-field-on-container-enabled',
    //hover
    'hover:bg-color-comp-text-field-container-hover',
    //read-only:
    'has-[textarea:read-only:not(:disabled)]:bg-color-comp-text-field-container-read-only',
    'has-[textarea:read-only:not(:disabled)]:text-color-comp-text-field-on-container-selected',
    //focus
    'has-[textarea:focus]:bg-color-comp-text-field-container-selected',
    'has-[textarea:focus]:text-color-comp-text-field-on-container-selected',
    //active
    'has-[textarea:active]:bg-color-comp-text-field-container-selected',
    'has-[textarea:active]:text-color-comp-text-field-on-container-selected',
    //visited
    'has-[textarea:visited]:bg-color-comp-text-field-container-entered',
    'has-[textarea:visited]:text-color-comp-text-field-on-container-selected',
    //disabled
    'has-[textarea:disabled]:bg-color-comp-text-field-container-disabled',
    'has-[textarea:disabled]:text-color-comp-text-field-on-container-disabled',
    //error
    'has-[textarea:invalid]:text-color-comp-text-field-on-container-selected',
    'has-[textarea[aria-invalid="true"]]:text-color-comp-text-field-on-container-selected',
    //not empty
    'has-[textarea:not([value=""])]:text-color-comp-text-field-on-container-selected',

    // BORDER WIDTH DEFINITION
    'before:absolute',
    'before:top-0',
    'before:right-0',
    'before:left-0',
    'before:bottom-0',
    'before:content-[""]',
    'before:rounded-radius-comp-form-round',
    'before:border-solid',
    'before:border-border-comp-text-field',
    //hover
    'before:hover:border-color-comp-text-field-border-hover',
    //read-only:
    'before:has-[textarea:read-only:not(:disabled)]:border-color-comp-text-field-border-read-only',
    //focus
    'before:has-[textarea:focus]:border-color-comp-text-field-border-selected',
    //active
    'before:has-[textarea:active]:border-color-comp-text-field-border-selected',
    //visited
    'before:has-[textarea:visited]:border-color-comp-text-field-border-entered',
    //disabled
    'before:has-[textarea:disabled]:border-color-comp-text-field-border-disabled',
    //error
    'before:has-[textarea:invalid]:border-color-comp-text-field-border-danger',
    'before:has-[textarea[aria-invalid="true"]]:border-color-comp-text-field-border-danger',
    //not empty
  ],
  {
    variants: {
      textAreaSize: {
        small: [
          'font-comp-text-field-web-small-text-font-family',
          'font-comp-text-field-web-small-text-font-weight',
          // font-size BEFORE leading: twMerge keeps Tailwind's default
          // font-size→clears-leading conflict, so a later font-size would drop
          // the line-height token (see @latitude/token-utils cn).
          'text-font-comp-text-field-web-small-text-font-size',
          'leading-font-comp-text-field-web-small-text-line-height',
          'py-spacing-comp-text-field-small-vertical',
          'pl-spacing-comp-text-field-small-horizontal-left',
          'pr-spacing-comp-text-field-small-horizontal-right',
        ],
        medium: [
          'font-comp-text-field-web-medium-text-font-family',
          'font-comp-text-field-web-medium-text-font-weight',
          // font-size BEFORE leading: see small variant above.
          'text-font-comp-text-field-web-medium-text-font-size',
          'leading-font-comp-text-field-web-medium-text-line-height',
          'py-spacing-comp-text-field-medium-vertical',
          'pl-spacing-comp-text-field-medium-horizontal-left',
          'pr-spacing-comp-text-field-medium-horizontal-right',
        ],
      },
      hasError: {
        true: [
          'before:border-color-comp-text-field-border-danger',
          'text-color-comp-text-field-on-container-selected',
        ],
        false: [
          'before:border-color-comp-text-field-border-enabled',
          'text-color-comp-text-field-on-container-enabled',
        ],
      },
    },
    defaultVariants: {
      textAreaSize: 'medium',
      hasError: false,
    },
  },
);

export const contentWrapper = cva(
  'relative flex w-full flex-row flex-wrap items-center justify-start space-x-1',
  {
    variants: {
      textAreaSize: {
        small: [
          'py-spacing-comp-text-field-small-text-area-vertical',
          'px-spacing-comp-text-field-small-text-area-horizontal',
          'text-font-comp-text-field-web-small-text-font-size',
          'gap-spacing-comp-text-field-small-gap',
          'leading-4',
        ],
        medium: [
          'py-spacing-comp-text-field-medium-text-area-vertical',
          'px-spacing-comp-text-field-medium-text-area-horizontal',
          'gap-spacing-comp-text-field-medium-gap',
          'text-font-comp-text-field-web-medium-text-font-size',
          'leading-6',
        ],
      },
    },
    defaultVariants: {
      textAreaSize: 'medium',
    },
  },
);
